(function () {
    'use strict';

    angular.module("imApp").factory("gisPositionAddService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1284,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1285,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
